import { render, staticRenderFns } from "./ModalDeleteLocationSubscription.vue?vue&type=template&id=06c836dc"
import script from "./ModalDeleteLocationSubscription.vue?vue&type=script&lang=js"
export * from "./ModalDeleteLocationSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports